module.exports = __webpack_public_path__ + "static/logo-the-cure-c6228e7074a8d780968f33a1602b6af2.png";